
import Header from '../components/Header'
import Footer from '../components/Footer'
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from 'react-lazyload';
const Library = () => {
    return(
        <>
            <Header/>
            <Breadcrumb pageTitle="Library" mid="Facilities" breadcrumbName="Library" />
            <div className='container facilities_img'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h3 className="sub-title">Library</h3>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library1.jpg'>
                           <LazyLoad> <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library1.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library2.jpg'>
                           <LazyLoad> <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library2.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library3.jpg'>
                            <LazyLoad><img src='https://webapi.entab.info/api/image/STHSM/public/Images/library3.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>

                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library4.jpg'>
                         <LazyLoad>   <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library4.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library5.jpg'>
                          <LazyLoad>  <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library5.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library6.jpg'>
                          <LazyLoad>  <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library6.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library7.jpg'>
                         <LazyLoad>   <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library7.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library8.jpg'>
                           <LazyLoad> <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library8.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                     
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library9.jpg'>
                       <LazyLoad>     <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library9.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library10.jpg'>
                          <LazyLoad>  <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library10.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library11.jpg'>
                           <LazyLoad> <img src='https://webapi.entab.info/api/image/STHSM/public/Images/library11.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                     
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://webapi.entab.info/api/image/STHSM/public/Images/library12.jpg'>
                            <LazyLoad><img src='https://webapi.entab.info/api/image/STHSM/public/Images/library12.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                     

                </div>
                 
            </div>
            <Footer />
        </>
    )
}
export default Library